import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * F12 (notification-sla-lifecycle §9.2) — редирект на единую поверхность настроек.
 *
 * Матрица «канал × триггер» переехала во вкладку центра уведомлений
 * (`/notifications?tab=settings`) вместе с параметром «за сколько дней предупреждать»
 * (B14). Роут СОХРАНЯЕТСЯ, а не удаляется: старые ссылки из писем, закладки и
 * упоминания в документации не должны отдавать 404.
 */
export const Route = createFileRoute('/_auth/me/task-notifications')({
  beforeLoad: () => {
    throw redirect({ to: '/notifications', search: { tab: 'settings' }, replace: true });
  },
});
